/**
 * Application version – fetched from the backend API.
 *
 * The backend's `settings.APPVERSION` is replaced during deployment
 * This hook fetches it via RTK Query and returns the version string.
 */
import { useGetAppVersionQuery } from '../../features/api/globalDataApi';

export function useAppVersion(): string {
  const { data } = useGetAppVersionQuery();
  return data?.version ?? '';
}
